// ChatTimelineItemBalloonPlan.vueでも興味あるするため、mixinに分離
import http from 'core/http';

const POST_LIKE_API_URL = '/api/likes';

export default {
  data() {
    return {
      isClosed: false,
      likableType: null,
      isSignedIn: false,
      isLike: false,
      likableId: null,
      likeCount: 0,
    };
  },
  computed: {
    likeText() {
      if (this.likableType === 'City') {
        if (this.isLike) {
          return 'フォロー中';
        }
        return 'フォロー';
      }
      if (this.isLike) {
        return '興味ある済み';
      }
      return '興味ある';
    },
  },
  methods: {
    onClickButton(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.isSignedIn) {
        if (this.likableType === 'City') {
          window.EventBus.$emit('need-signup-prompt', 'フォロー');
        } else {
          window.EventBus.$emit('need-signup-prompt', '興味ある');
        }
      } else if (!this.isLike) {
        this.postLike().then(() => {
          this.isLike = true;
          this.likeCount += 1;
        });
      } else {
        // Sign In済みでLike済み
        this.postLikeCanceled().then(() => {
          this.isLike = false;
          this.likeCount -= 1;
        });
      }
    },
    // likeボタン
    async postLike() {
      await http.post(POST_LIKE_API_URL, {
        like: { likable_type: this.likableType, likable_id: this.likableId },
      });
    },
    // likeの取り消し
    async postLikeCanceled() {
      await http.post(POST_LIKE_API_URL, {
        delete: true,
        like: { likable_type: this.likableType, likable_id: this.likableId },
      });
    },
  },
};
